var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49996 0.666504C6.05793 0.666504 5.63401 0.842099 5.32145 1.15466C5.00889 1.46722 4.83329 1.89114 4.83329 2.33317V3.99984H6.49996V2.33317H15.6666V11.4998H14V13.1665H15.6666C16.1087 13.1665 16.5326 12.9909 16.8451 12.6783C17.1577 12.3658 17.3333 11.9419 17.3333 11.4998V2.33317C17.3333 1.89114 17.1577 1.46722 16.8451 1.15466C16.5326 0.842099 16.1087 0.666504 15.6666 0.666504H6.49996ZM2.33329 4.83317C1.89127 4.83317 1.46734 5.00877 1.15478 5.32133C0.842221 5.63389 0.666626 6.05781 0.666626 6.49984V15.6665C0.666626 16.1085 0.842221 16.5325 1.15478 16.845C1.46734 17.1576 1.89127 17.3332 2.33329 17.3332H11.5C11.942 17.3332 12.3659 17.1576 12.6785 16.845C12.991 16.5325 13.1666 16.1085 13.1666 15.6665V6.49984C13.1666 6.05781 12.991 5.63389 12.6785 5.32133C12.3659 5.00877 11.942 4.83317 11.5 4.83317H2.33329ZM2.33329 6.49984H11.5V15.6665H2.33329V6.49984Z",
    fill: "url(#paint0_linear_7092_5335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7092_5335",
    x1: 17.3333,
    y1: 0.666504,
    x2: 0.666626,
    y2: 18.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CD3438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD203"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyImage);
export default __webpack_public_path__ + "static/media/copyImage.655d92fd6e03d40be6fa89e08800cf56.svg";
export { ForwardRef as ReactComponent };